export enum TermsOfDelivery {
  CFR = 'CFR',
  CIF = 'CIF',
  CIP = 'CIP',
  CPT = 'CPT',
  DAF = 'DAF',
  DAP = 'DAP',
  DDP = 'DDP',
  DDU = 'DDU',
  DEQ = 'DEQ',
  DES = 'DES',
  EXW = 'EXW',
  FAS = 'FAS',
  FCA = 'FCA',
  FOB = 'FOB',
  UNKNOWN = 'UNKNOWN',
}
